// Adapted from:
//  - https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/builders/buildRoutingRules.ts
//  - https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/builders/buildRoutingRulesFromType.ts
import { fromJS } from 'immutable';
import get from 'transmute/get';
import set from 'transmute/set';
import * as RoutingTypes from '../constants/RoutingTypes';
import { getType } from '../operators/routingRulesGetters';
import BotRoutingRules from '../records/BotRoutingRules';
import InboxUsersRoutingRules from '../records/InboxUsersRoutingRules';
import UnassignedRoutingRules from '../records/UnassignedRoutingRules';
import UsersAndTeamsRoutingRules from '../records/UsersAndTeamsRoutingRules';
import AiChatbotRoutingRules from '../records/AiChatbotRoutingRules';
import OwnerRoutingRules from '../records/OwnerRoutingRules';
export const setFallback = options => {
  const optionMap = fromJS(options || {});
  const fallback = get('fallback', optionMap);

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return set('fallback', buildRoutingRules(fallback), optionMap);
};
export const buildRoutingRulesFromType = (routingType, options) => {
  switch (routingType) {
    case RoutingTypes.USERS_AND_TEAMS:
      return new UsersAndTeamsRoutingRules(options);
    case RoutingTypes.OWNER:
      return new OwnerRoutingRules(options);
    case RoutingTypes.INBOX_USERS:
      return new InboxUsersRoutingRules();
    case RoutingTypes.BOT:
      return new BotRoutingRules(options);
    case RoutingTypes.AI_CHATBOT:
      return new AiChatbotRoutingRules(options);
    default:
      return new UnassignedRoutingRules();
  }
};
export const buildRoutingRules = options => {
  const routingType = getType(options);
  return buildRoutingRulesFromType(routingType, options || undefined);
};